/**
 * @file: getVehicleAgeByVin.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { kNullVIN } from '@euler/functions/constants';
import { is_valid_vin, vin_decode } from '@euler/utils/vin/parser';

/**
 * Age in years, or 0 when it cannot be established. A vehicle with no ISO VIN
 * carries the placeholder, so its year cannot be decoded — the model year the
 * operator typed is the only thing left to go on.
 */
export const getVehicleAgeByVin = (
  vin: string | null | undefined,
  modelYear?: number | null,
) => {
  const currentYear = new Date().getFullYear();
  if (!vin || vin === kNullVIN || !is_valid_vin(vin)) {
    return modelYear ? Math.max(1, currentYear - modelYear) : 0;
  }
  const decodedVinInfo = vin_decode(vin);
  return Math.max(1, currentYear - decodedVinInfo.production_year);
};
